import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';

import { Link, useLocation } from 'react-router-dom';
import App from '~/layouts/App';
import AddProduct from './AddProduct';
import FloatingVipButton from './components/FloatingVipButton';

import { useBanners } from '~/hooks/banners';
import { useCategories } from '~/hooks/categories';
import { useProducts } from '~/hooks/products';
import { useSettings } from '~/hooks/settings';
import IProduct from '~/interfaces/IProduct';
import getCurrencyFormatted from '~/utils/getCurrencyFormatted';

const global: any = window;
let swipe: any;
let swipeBanners: any;
let bannerInterval: any;

interface Group {
  [key: string]: IProduct[];
}

const placeholder =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAMAAAAGjUrGAAAAMFBMVEXx8/XCy9K/yND09vfw8vTP1tzp7O/i5ure4+fO1dvJ0dfT2d/EzNPt7/Lb4OXo6+4FeM7UAAAFL0lEQVR4nO2c24KrIAxFLdha7///t0dxOlWDSiAKztnrbR4G6SoJBKHZA6zJYncgQeCEAicUOKHACQVOKHBCgRMKnFDghAInFDihwAkFTihwQoETCpxQ4IQCJxQ4ocAJBU4ocEKBEwqcUOCEAicUOKHACQVOKHBCgRMKnFDghAInFDihwAkFTihwQoETCpxQ4IQCJxQ4ocAJBU4ot3Oi1KMq64FnWTVq+EueWzlRquqKVn/J+/ezEfdyHydKPYtc62yF1m1Xymq5ixPVdDnx8eslf1eCVu7hRFXFppAfLW39kNJyByeqOTJirGTvRsbKDZyozsHIpKUQsZK8E1Vu55GTrKTuRL0ZRoyVLviZaTtRVctUMuaVOnCoJO1E1WwjxsorbGZO2Qk7br5WuhApKTvpfZWMy5WAoZKuk6b1NhI4VJJ10uRBSsas0ng+OlUnVaARw9NvqCTqRERJpt9eUtJ0IqPEN36SdNIIKRnIPeafFJ0Ep9c5mr+qTdFJ2CRMpLAn5fScqJeokrFWZkoRdaImwtpw2T9iSnnxuiDoRFXda6hK28JzWTA14ryBxKFlTT9iTlT1W57o3Lta96yED8krRieknCw/DDuEP1TnKBlgzMlCTtZDXr+8pIjOwitK5x7JOKFD3mukiE85ix45S5FxYll46prdiv8ekpsU19wv4kS9LV1ouQPlrPzKliIzTuw9YDYiVfgFSxFx8rR+wcyMomSX9HYpTjlFwonqrB3gBc/JyYQjRcRJYe8Ay4l9rMlLcVi8iTjp7Y/nOBHcMjngWEoi4+TUlcmKw9rnxHzCWMqeU/ltkB9JEZl3SusnYmwQn1fm2GgPeiOzZrM9WZfu/3/BNDznYATLOLENffep+JppeMZBMSZUF9N6ljFM7KF3qpTduBZyQj4W53XTiRsEm1L2dr2k9k9W9Rtjq2BrJj9Zyk7pI7bP9lw8kfH+4KIFLGF77Sa3R90Un0POvHNCcYzsLVMk9+2buni1bd9xjMSJHMPmjCz7zov/fidW5GQ7OS/2e8BoRrLtrBfXScTIMVLsk09cJxEjZ8I6+cR1EmG1tsRaDsZ0EjlyDL0leuxOpulD4JTALtfXORRbnqVO1LDOePdtpoclWPsqulL+wt0P0SNnxFKrrp2opmuXl+5OuHA3PSmByDGQ9ezSydYdM+ELd4YUIsdANnoWTva2RSUv3JlnJRE5I2RbY+6kee1+dTrrhC7cPTZeMUdivZnydaIc3tdqqWuI6USOYZlSfp0oxzVlJxNByUSOYZlSPk6cDzqEXy17JDTn/LBMKRlTSRZ4X2giep2zZnEwZHLiGjifFt6BTtKKHMMspUxO2BkvDzoDm1jkGGa7bsaJx0t9XfgrOfuMlhezwsc48RrKufvhyiXXHatg8T2Zkm0eHzluxO8W4pXHKljkXycBt3h9blFdeqyCx2fPOguLbn6qTWsBu+Czxs/CopsdP4kmkx+mcZ8FRrfuWUqSTSYT005keDucW4iXnzRhMg17iYacC6A0VyZzzIQs0pBrUrn22JoXY4Us0pDjaZMzb+dIMX6/Qi0dHSU0XHySz48heqSaOs60vsvlq2mtpzj9OCh/Trgjew7afgLar63d6ec2SmTZm37+UyV7048K+Gmkm7O10A/8aaSbY7sEr8rYvYoNnX4Sr3EuYJVpVc35Ccu/innZbryMJ1n4v9f4N9FZ39XPZ931GYzMGH9VPHYfAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADp8Q9+nG9anuOrfAAAAABJRU5ErkJggg==';

const Home: React.FC = () => {
  const { search: query } = useLocation();
  const { company } = useSettings();
  const {
    loadProducts,
    products,
    isInitialized: productInitialized,
  } = useProducts();
  const {
    loadCategories,
    categories,
    loadComplements,
    complements,
    isInitialized,
  } = useCategories();
  const {
    loadBanners,
    banners,
    isInitialized: bannerInitialized,
  } = useBanners();

  const [product, setProduct] = useState({} as IProduct);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const filter = products.filter(item =>
      item.name.toLocaleLowerCase().includes(search.toLocaleLowerCase()),
    );

    filter.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));

    return filter;
  }, [products, search]);

  const handleLoadComplements = useCallback(async () => {
    if (company.uid && complements.length === 0) loadComplements(company.uid);
  }, [company, loadComplements]);

  const handleLoadCategories = useCallback(async () => {
    if (company.uid) loadCategories(company.uid);
  }, [company, loadCategories]);

  const handleLoadProducts = useCallback(async () => {
    await loadProducts();
    setLoading(false);
  }, [loadProducts]);

  useEffect(() => {
    if (company.uid && !bannerInitialized) loadBanners(company.uid);
  }, [company, loadBanners, bannerInitialized]);

  useEffect(() => {
    if (!isInitialized) handleLoadCategories();
  }, [handleLoadCategories, isInitialized]);

  useEffect(() => {
    if (!isInitialized) handleLoadComplements();
  }, [handleLoadComplements, isInitialized]);

  useEffect(() => {
    const handleFocus = () => {
      if (company.uid) {
        loadComplements(company.uid);
      }
    };

    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, [company.uid, loadComplements]);

  useEffect(() => {
    if (!productInitialized) handleLoadProducts();
  }, [handleLoadProducts, productInitialized]);

  useEffect(() => {
    if (filtered && filtered.length > 0) {
      setTimeout(() => {
        swipe = new global.Swiper('.products', {
          slidesPerView: 2,
          spaceBetween: 8,
          breakpoints: {
            992: {
              slidesPerView: 5,
              spaceBetween: 8,
            },
            600: {
              slidesPerView: 3,
              spaceBetween: 8,
            },
            0: {
              slidesPerView: 2,
              spaceBetween: 8,
            },
          },
        });
      }, 1000);

      setTimeout(() => {
        swipe = new global.Swiper('.products', {
          slidesPerView: 2,
          spaceBetween: 8,
          breakpoints: {
            992: {
              slidesPerView: 5,
              spaceBetween: 8,
            },
            600: {
              slidesPerView: 3,
              spaceBetween: 8,
            },
            0: {
              slidesPerView: 2,
              spaceBetween: 8,
            },
          },
        });
      }, 4000);
    }
    if (products && products.length === 0) setLoading(true);
  }, [filtered, products]);

  useEffect(() => {
    if (categories && categories.length > 0) {
      swipe = new global.Swiper('.categoriesswiper', {
        slidesPerView: 4,
        spaceBetween: 8,
        breakpoints: {
          992: {
            slidesPerView: 10,
            spaceBetween: 8,
          },
        },
      });

      swipe.toString();
    }
  }, [categories]);

  useEffect(() => {
    if (banners && banners.length > 0) {
      swipeBanners = new global.Swiper('.bannersswiper', {
        init: true,
        speed: 400,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 8,
        allowSlideNext: true,
        breakpoints: {
          992: {
            slidesPerView: 2,
            spaceBetween: 8,
          },
        },
      });

      bannerInterval = setInterval(() => {
        swipeBanners.slideNext();
      }, 5000);
    }

    return () => {
      clearInterval(bannerInterval);
    };
  }, [banners]);

  const categoriesIds = useMemo(() => {
    return categories.map(item => item.uid);
  }, [categories]);

  const parseProducts = useMemo(() => {
    const arr: Group = {};

    categories.forEach(item => {
      arr[item.uid] = [];
    });

    filtered.sort((a, b) =>
      a.category.order > b.category.order
        ? 1
        : b.category.order > a.category.order
        ? -1
        : 0,
    );

    filtered.forEach(product => {
      const category = categories.find(
        item => item.uid === product.category.uid,
      );

      if (categoriesIds.includes(product.category.uid)) {
        if (!arr[product.category.uid]) arr[product.category.uid] = [];

        arr[product.category.uid].push({
          ...product,
          category: {
            ...product.category,
            name: category?.name || '',
          },
        });
      }
    });

    console.log('arr0', arr);

    Object.entries(arr).forEach(([key, items]) => {
      arr[key].sort((a, b) =>
        a.order > b.order ? 1 : b.order > a.order ? -1 : 0,
      );
    });

    console.log('arr1', arr);

    return arr;
  }, [filtered, categoriesIds, categories]);

  const handleClickCategory = useCallback(category_id => {
    const element = document.getElementById(category_id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }, []);

  const handleClickProduct = useCallback((item: IProduct) => {
    setProduct(item);
  }, []);

  return (
    <App loading={loading}>
      {banners.length > 0 && (
        <div
          id="banners"
          className="swiper-container bannersswiper sticky mb-3 mt-3"
        >
          <div className="swiper-wrapper">
            {banners.map(banner => (
              <div className="swiper-slide" key={banner.uid}>
                <img
                  src={banner.image}
                  alt="banner"
                  style={{
                    width: '100%',
                    height: 250,
                    borderRadius: 8,
                    objectFit: 'contain',
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="row mb-4 mt-4">
        <div className="col">
          <div
            className="form-floating"
            style={{
              border: '1px solid rgba(0, 0, 0, 0.125)',
              borderRadius: 8,
            }}
          >
            <input
              type="text"
              className="form-control"
              id="search"
              placeholder="Buscar..."
              onChange={event => {
                setSearch(event.target.value);
              }}
            />
            <label htmlFor="search">Buscar...</label>
            <button
              type="button"
              className="btn btn-link tooltip-btn d-block text-color-theme"
              style={{ color: company.app_color }}
            >
              <i className="bi bi-search" />
            </button>
          </div>
        </div>
      </div>

      <div
        id="categories"
        className="swiper-container categoriesswiper sticky mb-3 mt-3"
      >
        <div className="swiper-wrapper">
          {categories.map(category => (
            <div
              className="swiper-slide"
              key={category.uid}
              onClick={() => handleClickCategory(category.uid)}
              style={{
                display: parseProducts[category.uid].length === 0 ? 'none' : '',
              }}
            >
              <div className="card">
                <div className="card-body" style={{paddingBottom: 4}}>
                  <img src={category.image || placeholder} alt="categoria" style={{ width: 50, height: 50, maxWidth: 50, maxHeight: 50, borderRadius: '100%', objectFit: 'cover' }} />
                </div>
              </div>
              <p className="categoryname">{category.name}</p>
            </div>
          ))}
        </div>
      </div>

      {Object.entries(parseProducts).map(([key, items]) => {
        if (items.length > 0) {
          return (
            <div id={key} key={key}>
              <div className="row mb-3">
                <div className="col">
                  <h5 className="mb-0">{items[0].category.name}</h5>
                </div>
                <div className="col-auto">
                  <Link
                    to={`/${company.app_domain}/category/${items[0].category.uid}${query}`}
                    className="link"
                    style={{ color: company.app_color }}
                  >
                    {'ver mais '}
                    <i className="bi bi-arrow-right" />
                  </Link>
                </div>
              </div>

              <div className="swiper-container products">
                <div className="swiper-wrapper">
                  {items.map(item => (
                    <div
                      className="swiper-slide"
                      key={item.uid}
                      onClick={() => handleClickProduct(item)}
                    >
                      <div
                        className="card shadow-sm product mb-4"
                        style={{ position: 'relative' }}
                      >
                        {item.enable_promotion && (
                          <span
                            className="badge badge-success ml-1"
                            style={{
                              position: 'absolute',
                              top: 6,
                              left: 0,
                              zIndex: 9,
                              background: '#1ee0ac',
                            }}
                          >
                            Promoção
                          </span>
                        )}
                        <figure
                          className="text-center mb-0 bg-light-warning product-home"
                          style={{
                            background: '#fff',
                          }}
                        >
                          <img
                            src={item.image || company.image}
                            alt={item.name}
                            className="custom-img"
                            style={{objectFit:'cover'}}
                          />
                        </figure>
                        <div className="card-body">
                          <h6
                            className="text-color-theme custom-text"
                            style={{ color: company.app_color }}
                          >
                            {item.name}
                          </h6>

                          <div className="row">
                            <div className="col">
                              {parseFloat(
                                item.enable_promotion
                                  ? item.value_promotion
                                  : item.value,
                              ) > 0 && (
                                <p className="mb-0">
                                  {getCurrencyFormatted(
                                    parseFloat(
                                      item.enable_promotion
                                        ? item.value_promotion
                                        : item.value,
                                    ),
                                  )}

                                  {item.enable_promotion && (
                                    <span
                                      className="mb-0"
                                      style={{
                                        textDecoration: 'line-through',
                                        marginLeft: 8,
                                        fontSize: 10,
                                      }}
                                    >
                                      {getCurrencyFormatted(
                                        parseFloat(item.value),
                                      )}
                                    </span>
                                  )}
                                </p>
                              )}

                              {parseFloat(item.value) === 0 && (
                                <p className="mb-0" style={{ fontSize: 12 }}>
                                  {item.description}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        }

        return <Fragment key={key} />;
      })}

      <AddProduct
        product={product}
        onClose={() => setProduct({} as IProduct)}
      />

      <FloatingVipButton />
    </App>
  );
};

export default Home;
